const isArray = Array.isArray || (x => x && typeof x.length === 'number');

export default isArray;



// WEBPACK FOOTER //
// ./src/app/services/utils/is-array.ts